import {
  _calculateEllipsisInfo,
  _ELLIPSIS_APPROXIMATION_THRESHOLD,
  _ELLIPSIS_CHARACTER,
  type _Font,
  _getTextWidth,
} from '@dynatrace/strato-components/typography';

export const truncateText = (
  originalText: string,
  textFont: _Font,
  maxWidthInPx: number,
  ellipsis?: boolean,
) => {
  const ellipsisInfo = _calculateEllipsisInfo(
    originalText,
    textFont,
    maxWidthInPx,
  );

  if (ellipsisInfo === null) {
    return originalText;
  }

  const { ellipsisWidth, avgLetterWidth } = ellipsisInfo;
  const ellipsisSymbolWidth = ellipsis ? ellipsisWidth : 0;
  const availableTextWidth = maxWidthInPx - ellipsisSymbolWidth;

  if (ellipsis && availableTextWidth <= ellipsisWidth) {
    return _ELLIPSIS_CHARACTER;
  }

  let prefix: string;
  let ellipsizedText: string;
  let approximatedTextWidth: number;
  let attempt = 1;
  let prefixLength = availableTextWidth / avgLetterWidth;

  do {
    prefixLength -= 1;

    prefix = originalText.substring(0, prefixLength);

    ellipsizedText = `${prefix}${_ELLIPSIS_CHARACTER}`;
    approximatedTextWidth = _getTextWidth(ellipsizedText, textFont);

    attempt++;
  } while (
    attempt <= _ELLIPSIS_APPROXIMATION_THRESHOLD &&
    approximatedTextWidth >= maxWidthInPx
  );

  return ellipsizedText;
};
